import { Dashboard, DashboardModel, WorkspaceScrollBehaviour, WorkspaceState } from '@ddv/models';

import { setWidgetExtraParamsFromDashboardDetails } from './set-widget-extra-params-from-dashboard-details';

export class Workspace {
    id = '';
    name = '';
    workspaceScrollBehaviour: WorkspaceScrollBehaviour | undefined;
    extraParameters: DashboardModel | undefined;
    isRendered = false;
    iconClass?: string;

    constructor(dashboardDetails?: Dashboard) {
        if (!dashboardDetails) {
            return;
        }

        this.id = dashboardDetails.id?.toString() ?? '';
        this.name = `${this.id}_${dashboardDetails.name}`;
        this.workspaceScrollBehaviour = {
            allowInfiniteHScroll: !!dashboardDetails.allowInfiniteHScroll,
            allowInfiniteVScroll: !!dashboardDetails.allowInfiniteVScroll,
        };
    }

    getExtraParameters(): DashboardModel | undefined {
        return this.extraParameters;
    }

    setExtraParameters(extraParameters: DashboardModel): void {
        this.extraParameters = extraParameters;
    }

    updateExtraParameters(updateFn: (extraParams: DashboardModel) => void): void {
        if (this.extraParameters) {
            updateFn(this.extraParameters);
        }
    }

    getWorkspaceState(): WorkspaceState {
        const workSpaceState = new WorkspaceState();
        workSpaceState.id = this.id;
        workSpaceState.name = this.name;
        return workSpaceState;
    }
}

export function createWorkspaceObj(dashboardDetails: Dashboard): Workspace {
    const workspace: Workspace = new Workspace(dashboardDetails);
    setWidgetExtraParamsFromDashboardDetails(dashboardDetails, workspace);
    return workspace;
}
